import React from 'react';
import Icon from '../../../components/AppIcon';

const StatusCodesTable = () => {
  const statusCodes = [
    {
      code: '200',
      status: 'OK',
      description: 'Request successful, data returned',
      category: 'success',
      example: 'Successfully retrieved product list'
    },
    {
      code: '201',
      status: 'Created',
      description: 'Resource successfully created',
      category: 'success',
      example: 'New product created successfully'
    },
    {
      code: '204',
      status: 'No Content',
      description: 'Request successful, no data to return',
      category: 'success',
      example: 'Product deleted successfully'
    },
    {
      code: '400',
      status: 'Bad Request',
      description: 'Invalid request parameters or format',
      category: 'client-error',
      example: 'Missing required field: product name'
    },
    {
      code: '401',
      status: 'Unauthorized',
      description: 'Authentication required or invalid',
      category: 'client-error',
      example: 'Invalid API key provided'
    },
    {
      code: '403',
      status: 'Forbidden',
      description: 'Access denied to requested resource',
      category: 'client-error',
      example: 'Insufficient permissions for this operation'
    },
    {
      code: '404',
      status: 'Not Found',
      description: 'Requested resource does not exist',
      category: 'client-error',
      example: 'Product with ID 123 not found'
    },
    {
      code: '422',
      status: 'Unprocessable Entity',
      description: 'Request format valid but contains semantic errors',
      category: 'client-error',
      example: 'Price cannot be negative'
    },
    {
      code: '500',
      status: 'Internal Server Error',
      description: 'Unexpected server error occurred',
      category: 'server-error',
      example: 'Database connection failed'
    },
    {
      code: '502',
      status: 'Bad Gateway',
      description: 'Invalid response from upstream server',
      category: 'server-error',
      example: 'Payment gateway unavailable'
    },
    {
      code: '503',
      status: 'Service Unavailable',
      description: 'Server temporarily unavailable',
      category: 'server-error',
      example: 'API maintenance in progress'
    }
  ];

  const getCategoryColor = (category) => {
    switch (category) {
      case 'success':
        return 'text-green-600 bg-green-50 border-green-200';
      case 'client-error':
        return 'text-orange-600 bg-orange-50 border-orange-200';
      case 'server-error':
        return 'text-red-600 bg-red-50 border-red-200';
      default:
        return 'text-gray-600 bg-gray-50 border-gray-200';
    }
  };

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'success':
        return 'CheckCircle';
      case 'client-error':
        return 'AlertTriangle';
      case 'server-error':
        return 'XCircle';
      default:
        return 'Info';
    }
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse border border-border rounded-lg">
        <thead>
          <tr className="bg-muted/50">
            <th className="border border-border px-4 py-3 text-left text-sm font-semibold text-foreground">
              Status Code
            </th>
            <th className="border border-border px-4 py-3 text-left text-sm font-semibold text-foreground">
              Status
            </th>
            <th className="border border-border px-4 py-3 text-left text-sm font-semibold text-foreground">
              Description
            </th>
            <th className="border border-border px-4 py-3 text-left text-sm font-semibold text-foreground">
              Example Scenario
            </th>
          </tr>
        </thead>
        <tbody>
          {statusCodes?.map((status, index) => (
            <tr key={status.code} className={index % 2 === 0 ? 'bg-background' : 'bg-muted/20'}>
              <td className="border border-border px-4 py-3">
                <div className="flex items-center space-x-2">
                  <Icon 
                    name={getCategoryIcon(status.category)} 
                    size={16} 
                    className={getCategoryColor(status.category)?.split(' ')?.[0]} 
                  />
                  <span className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium border ${getCategoryColor(status.category)}`}>
                    {status.code}
                  </span>
                </div>
              </td>
              <td className="border border-border px-4 py-3 text-sm font-medium text-foreground">
                {status.status}
              </td>
              <td className="border border-border px-4 py-3 text-sm text-muted-foreground">
                {status.description}
              </td>
              <td className="border border-border px-4 py-3 text-sm text-muted-foreground">
                {status.example}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StatusCodesTable;